/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef } from 'react';

import WebViewer from '@pdftron/webviewer';

import { setInstance } from './DraftSlice';
import { useAppDispatch } from '../../redux/store';

const DocxViewerComponent = (props: any) => {
  const documentContainer = useRef<HTMLDivElement>(null);
  const { fileLink, draftDetails } = props;
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (fileLink && documentContainer.current && draftDetails) {
      const extension = draftDetails?.name?.split('.')?.[1] || 'docx';
      WebViewer.WebComponent(
        {
          path: '/webviewer',
          fullAPI: true,
          initialDoc: fileLink,
          extension: extension,
          disabledElements: [
            'header',
            'toolsHeader',
            'linkButton',
            'annotationCommentButton',
            'contextMenuPopup',
          ],
          licenseKey:
            'Riverus Technology Solutions Pvt. Ltd (riverus.in):OEM:Riverus::B+:AMS(20240530):A65548BC0477C80A0360B13AB9C2527160610FEBB9361A37E36C05DA5CF50ED654BA31F5C7',
        },
        documentContainer.current
      ).then((instance) => {
        const { UI, Core } = instance;
        const { documentViewer } = Core;
        instance.UI.annotationPopup.update([{ type: 'ac' }]);
        documentViewer.addEventListener('documentLoaded', async () => {
          const FitMode = instance.UI.FitMode;
          instance.UI.setFitMode(FitMode.FitWidth);
          dispatch(setInstance(instance));
        });

        if (!draftDetails?.open_collab) {
          UI.disableElements(['textPopup']);
        }
      });
    }
  }, [fileLink, documentContainer, setInstance, draftDetails]);

  return (
    <div
      ref={documentContainer}
      id="document-viewer"
      style={{ height: '82vh' }}
    />
  );
};

export default DocxViewerComponent;
